import { InjectionToken } from '@angular/core';
import { MmuLogLevel } from './mmu-log-level.enum';
import { setupLogLevel } from './setup-log-level';

export const MMU_LOG_LEVEL = new InjectionToken<MmuLogLevel | undefined>('MMU_LOG_LEVEL', {
  providedIn: 'root',
  factory: setupLogLevel
});
